<template>
  <div class="black-board-container">
    <img class="background-img" src="../../../assets/img/home/home_bg.jpg" alt="" />
    <div class="black-board-body body-max-container">
      <div v-if="isLoadedEnd" class="pc-cat-box">
        <img class="pc-img" src="../../../assets/img/home/home-pc.svg" alt="" />
        <div class="fqa-box" @click="handleScrollToFQA">
          <div class="input-title enter-btn"><span>常見問題</span></div>
          <img class="fqa-img-1 enter-btn" src="../../../assets/img/home/home-fqa-1.svg" alt="" />
          <img class="fqa-img-2 enter-btn" src="../../../assets/img/home/home-fqa-2.svg" alt="" />
        </div>
        <div class="cat-box">
          <img class="cat-img" src="../../../assets/img/home/cat/home-cat.jpg" alt="" />
          <div class="cat-split-img cat-hand-pen-box enter-btn">
            <img class="cat-hand-pen-img" src="../../../assets/img/home/cat/cat-hand-pen.svg" alt />
            <img class="cat-hand-img" src="../../../assets/img/home/cat/cat-hand.png" alt />
            <img class="cat-chalk-img" src="../../../assets/img/home/cat/chalk.png" alt />
            <div class="input-title game"><span>小遊戲</span></div>
          </div>
          <img class="cat-split-img cat-body-img" src="../../../assets/img/home/cat/cat-body.png" alt="" />
          <img class="cat-split-img cat-head-img" src="../../../assets/img/home/cat/cat-head.png" alt="" />
          <div class="hand-book-box">
            <img class="cat-split-img cat-hand-book-img enter-btn" src="../../../assets/img/home/cat/cat-hand-book.png" alt @click="goPage('ResourceIndex')" />
            <div class="input-title resource enter-btn" @click="goPage('ResourceIndex')"><span>教育資源</span></div>
          </div>
        </div>
      </div>
      <div class="book-clock-box">
        <div class="clock-with-title">
          <span class="enter-btn" @click="goPage('News')">最新消息</span>
          <img class="clock-img enter-btn" src="../../../assets/img/home/home-clock.svg" alt @click="goPage('News')" />
        </div>
        <img class="book-img" src="../../../assets/img/home/home-book.svg" alt />
      </div>
      <div class="photo-frame-box">
        <span @click="goPage('12Nights2')">觀看電影</span>
        <img class="photo-frame-img enter-btn" src="../../../assets/img/home/home-photo-frame.svg" alt="" @click="goPage('12Nights2')" />
      </div>
      <div class="cup-box">
        <span class="enter-btn" @click="goPage('Recommendation')">聽聽他們說</span>
        <img class="cup-img enter-btn" src="../../../assets/img/home/home-cup.svg" alt @click="goPage('Recommendation')" />
      </div>
      <div class="tree-box enter-btn" @click="goPage('About')">
        <span>累積成果與進度</span>
        <img class="tree-img" src="../../../assets/img/home/home-tree.svg" alt />
        <img class="plant-img" src="../../../assets/img/home/plant/plant.png" alt />
        <img class="pot-img" src="../../../assets/img/home/plant/pot.png" alt />
        <img class="leaves-b-img" src="../../../assets/img/home/plant/leaves_B.png" alt />
        <img class="leaves-c2-img" src="../../../assets/img/home/plant/leaves_C2.png" alt />
        <img class="leaves-c-img" src="../../../assets/img/home/plant/leaves_C.png" alt />
        <img class="leaves-d-img" src="../../../assets/img/home/plant/leaves_D.png" alt />
        <img class="leaves-e-img" src="../../../assets/img/home/plant/leaves_E.png" alt />
        <img class="leaves-f-img" src="../../../assets/img/home/plant/leaves_F.png" alt />
        <img class="leaves-a-img" src="../../../assets/img/home/plant/leaves_A.png" alt />
      </div>
      <div class="pencil-yellow-box enter-btn" @click="goPage('MessageBoard')">
        <img class="pencil-yellow-img" src="../../../assets/img/home/home-pencil-yellow.svg" alt="" />
      </div>
      <div class="pencil-orange-box">
        <span class="enter-btn" @click="goPage('MessageBoard')">留言去</span>
        <img class="pencil-orange-img enter-btn" src="../../../assets/img/home/home-pencil-orange.svg" alt  @click="goPage('MessageBoard')" />
      </div>
      <div class="title-box">
        <span class="title">光之沃土</span>
        <span class="sub-title">教育資源平台</span>
        <img src="../../../assets/img/facebook-icon.svg" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeBlackBoard",
  props: {
    isLoadedEnd: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goPage(page) {
      if (page === "12Nights2") {
        this.$12nightsConfirm({
          title: "您將前往前往外部連結",
          message: "https://youtu.be/PfZdrRygmec"
        }).then(() => {
          window.open("https://youtu.be/PfZdrRygmec", '_blank')
        })
      } else if (this.$route.name !== page) {
        this.$router.push({
          name: page
        });
      }
    },
    handleScrollToFQA() {
      document.getElementById("homeFQA").scrollIntoView({ behavior: "smooth"});
    }
  }
};
</script>

<style lang="scss" scoped>
</style>

